import script from "./ModifyPaymentPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ModifyPaymentPassword.vue?vue&type=script&setup=true&lang=js"

import "./ModifyPaymentPassword.vue?vue&type=style&index=0&id=46166efc&lang=less&scoped=true"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46166efc"]])

export default __exports__